import clsx from "clsx";

function StatusCell({
  value,
}: {
  value:
    | ""
    | "Assigned"
    | "Cancelled"
    | "Completed"
    | "Failed"
    | "In Transit to Drop-off"
    | "In Transit to Pickup"
    | "In Transit"
    | "Not Started"
    | "Unassigned";
}) {
  if (!value) {
    return "";
  }

  let statusStyles = "";

  if (value === "Assigned") {
    statusStyles = "bg-purple-200 text-purple-700";
  }

  if (value.includes("In Transit")) {
    statusStyles = "bg-blue-100 text-blue-800";
  }

  if (value === "Completed") {
    statusStyles = "bg-emerald-100 text-green-800";
  }

  if (value === "Failed" || value === "Cancelled") {
    statusStyles = "bg-red-200 text-red-700";
  }

  if (value === "Unassigned" || value === "Not Started") {
    statusStyles = "bg-gray-200 text-gray-700";
  }

  return (
    <div className={clsx("p-1 px-2 rounded-full", statusStyles)}>{value}</div>
  );
}

export default StatusCell;
